module.exports = __webpack_public_path__ + "img/illu-card-beschwerden-paralysis.27870437.svg";